import React from 'react'
import { Col, Row } from 'react-bootstrap'
import connectionImg from '../../../../assets/images/connection-img.png'

const Connections = () => {
    return (
        <section className="about-us">
            <div className="appContainer">
                <Row className='align-items-center'>
                    <Col xs={12} lg={6} className='my-3'>
                        <h2>More Than Matches Meaningful Connections.</h2>
                        <p className='grey-text fs-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan </p>
                    </Col>
                    <Col xs={12} lg={6} className='my-3'>
                        <img src={connectionImg} alt="connection" className='img-fluid' />
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Connections
